import styled from '@emotion/styled'
import { breakpoint } from '../../../__styling/style-functions/breakpoint'
import { calcRem } from '../../../__styling/style-functions/calc-rem'

interface OlympicWidgetStyleProps {
    isFullSize: boolean
}

export const StyledFlexRow = styled('section')<OlympicWidgetStyleProps>(
    ({ theme, isFullSize }) => ({
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        width: '100%',
        justifyContent: isFullSize ? 'flex-end' : 'flex-start',
        [breakpoint('sm')]: {
            width: 'unset',
        },
    }),
)

export const StyledHeadingFlexRow = styled(
    StyledFlexRow,
)<OlympicWidgetStyleProps>(({ theme, isFullSize }) => ({
    flexDirection: isFullSize ? 'column' : 'row',
    alignItems: isFullSize ? 'flex-start' : 'center',
    justifyContent: 'space-between',
    [breakpoint('sm')]: {
        flexDirection: 'row',
        alignItems: 'center',
    },
}))

export const StyledTitle = styled('h5')<OlympicWidgetStyleProps>(
    ({ theme, isFullSize }) => ({
        fontSize: isFullSize ? calcRem(32) : calcRem(15),
        textTransform: 'uppercase',
        color: theme.colors.actions.link.default,
        margin: '0',
    }),
)
